import * as Yup from 'yup';
import { BonusCondition } from '@synergy/models';
import { fields } from '@synergy/utils';

const fieldNames = fields<BonusCondition>();

export const bonusConditionsValidationSchema = Yup.object().shape({
    [fieldNames.title]: Yup.string().required('app.error.required'),
    [fieldNames.responsibleContactEmail]: Yup.string().email('app.error.email').required('app.error.required'),
    [fieldNames.responsibleContactId]: Yup.number().typeError('app.error.required').required('app.error.required'),
    [fieldNames.supplierPayout]: Yup.number()
        .min(0, 'app.error.greaterZero')
        .max(100, 'app.error.lesserHundred')
        .typeError('app.error.required'),
    [fieldNames.description]: Yup.string().nullable(true).max(300, 'app.error.maxLength'),
    [fieldNames.conditionFrom]: Yup.date().nullable(true),
    [fieldNames.conditionTo]: Yup.date().nullable(true).min(Yup.ref('conditionFrom'), 'app.error.minStartDate'),
});
